import { format } from 'date-fns'
import { configApi } from '../http-client.js'
import { DATE_FORMAT } from '../date-formatting.js'

export const getSSOConfiguration = () => configApi.get('/api/SSOConfiguration').then(({ data }) => ({
	data: {
		ssoConfigurations: data.ssoConfigurations.map(ssoConfiguration => ({
			...ssoConfiguration,
			productName: ssoConfiguration.productId === 1 ? 'Administration Portal' : 'Customer Service Portal',
			createdDate: ssoConfiguration.dateCreated ? format(new Date(ssoConfiguration.dateCreated), DATE_FORMAT) : 'Not Configured'
		})),
		lookupData: data.lookupData
	}
}))

export const postSSOConfiguration = ssoConfiguration => configApi.post('/api/SSOConfiguration', ssoConfiguration)

export const putSSOConfiguration = (ssoConfiguration, id) => configApi.put(`/api/SSOConfiguration/${id}`, ssoConfiguration)

export const toggleSSOConfiguration = configuration => configApi.put('/api/SSOConfiguration/ToggleSsoConfiguration', configuration)

// SCIM Token Management
export const createScimToken = (configId, data) => configApi.post(`/api/SSOConfiguration/${configId}/scim-token`, data)

export const revokeScimToken = configId => configApi.delete(`/api/SSOConfiguration/${configId}/scim-token`)

// SCIM Groups
export const getScimGroups = tenantGuid => configApi.get(`/api/SSOConfiguration/scim-groups/${tenantGuid}`)

export const getScimAuditLogs = (configId, query) => configApi.get(`/api/SSOConfiguration/${configId}/scim-audit-logs`, { params: query })
